import { get } from "lodash";
import {
  getPersonPageTitleQuery,
  getPositionPageTitleQuery,
  getTeamTitleQuery,
  getTagPageTitleQuery,
} from "src/queries/pageTitle.graphql";
import { getName } from "src/util/person";
import { groupTypeAsText } from "src/util/groupType";
import {
  getPersonTitleWithOptionQuery,
  getTeamTitleWithOptionQuery,
} from "src/pages/Designs/overlay/designOptionGraphql";

export const PAGE_TITLE_CONFIGS = {
  personDetailPage: {
    query: getPersonPageTitleQuery,
    // Same `person { names }` shape, read from the selected design option.
    optionQuery: getPersonTitleWithOptionQuery,
    mapper: (data, id) => {
      // An option read can return person: null (not visible yet), not just
      // no data, so guard the person itself or the tab title goes blank.
      if (!data?.person) {
        return `Person ${id}`;
      }
      return getName(data.person);
    },
  },
  positionDetailPage: {
    query: getPositionPageTitleQuery,
    mapper: (data, id) =>
      !data ? `Position ${id}` : data?.position?.name || `Position ${id}`,
  },
  teamDetailPage: {
    query: getTeamTitleQuery,
    // Same `team { name type }` shape, read from the selected design option.
    optionQuery: getTeamTitleWithOptionQuery,
    mapper: (data, id, groupTypes) => {
      // An option read can return team: null (a team only the option has,
      // not visible yet), not just no data.
      if (!data?.team?.name) {
        return `Team ${id}`;
      }
      const teamType = get(groupTypes, data.team.type, {
        name: data.team.type,
        noConfig: true,
      });
      return `${data.team.name} [${groupTypeAsText(teamType)}]`;
    },
  },
  tagDetailPage: {
    query: getTagPageTitleQuery,
    mapper: (data, id) => {
      const tag = data?.tag?.[0];
      const displayValue = tag?.displayValue;
      const type = tag?.type;
      if (
        !tag ||
        displayValue === undefined ||
        displayValue === null ||
        displayValue === ""
      ) {
        return `Tag ${id}`;
      }
      return `${displayValue} [${type ?? ""}]`;
    },
  },
  dashboard: {
    query: getPersonPageTitleQuery,
    mapper: (data) => getName(data),
    isDashboard: true,
  },
};
